export default "__VITE_ASSET__CjftnsE0__"